// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"112a17c4","455":"75f101bc","977":"26ccafca"}[chunkId] + ".chunk.js";
};